import React from 'react';
import { usePortal } from '../contexts/PortalContext';
import type { ClientRoute } from '../contexts/PortalContext';
import { brand } from '../data/projects';
import { ContactPortal } from './ContactPortal';
const NAV: {
  label: string;
  route: ClientRoute;
}[] = [{
  label: 'Project',
  route: 'project'
}, {
  label: 'Deliverables',
  route: 'episodes'
}, {
  label: 'Files',
  route: 'files'
}, {
  label: 'Schedule',
  route: 'schedule'
}];
export function ClientShell({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    clientRoute,
    goClient,
    activeProject,
    changeClientName,
    clientPreview
  } = usePortal();
  const [contactOpen, setContactOpen] = React.useState(false);

  /**
   * In a staff preview the page reads exactly as the client's does, but the
   * two controls that would write or change who is signed in do nothing.
   */
  const openContact = clientPreview ? undefined : () => setContactOpen(true);
  return <div className="min-h-screen w-full bg-paper text-ink" data-id="element-29" data-mp="37qxfrtfvlglj">
      <header className="border-b border-rule" data-id="element-30" data-mp="ichw0q8tsrhj">
        <div className="mx-auto flex max-w-portal flex-col gap-5 px-6 py-6 sm:px-10 md:flex-row md:items-center md:justify-between" data-id="element-31" data-mp="id9fj2p5eyrg">
          <button type="button" onClick={() => goClient('home')} className="block self-start text-left transition-opacity duration-150 ease-out hover:opacity-60" data-id="element-32" data-mp="dbtxzkm6jadt">
            {/* The same supplied wordmark as the studio side, in its dark form. */}
            <img src={brand.lockup} alt="Portal Productions" className="h-5 w-auto sm:h-6" data-id="element-33" data-mp="1152c173ff23x" />
            <span className="label-sm mt-2.5 block text-mute" data-id="element-34" data-mp="1a2w3a3mc35k8">Client Portal</span>
          </button>

          <div className="flex items-center justify-between gap-8 md:justify-end" data-id="element-35" data-mp="163dlvhtq1cm5">
            <nav aria-label="Client sections" data-id="element-36" data-mp="3buimvk3wby6o">
              <ul className="m-0 flex list-none gap-6 p-0 sm:gap-8" data-id="element-37" data-mp="3bvk8giijg32n">
                {NAV.map(item => {
                const active = clientRoute === item.route || item.route === 'episodes' && clientRoute === 'episode';
                return <li key={item.route} data-id="element-38" data-mp="1fse3x76iaky4">
                      <button type="button" onClick={() => goClient(item.route)} aria-current={active ? 'page' : undefined} className={['label whitespace-nowrap pb-1 transition-colors duration-150 ease-out', active ? 'border-b border-ink text-ink' : 'border-b border-transparent text-mute hover:text-ink'].join(' ')} data-id="element-39" data-mp="1kqphnszx9flm">
                        {item.label}
                      </button>
                    </li>;
              })}
              </ul>
            </nav>
            <button type="button" onClick={openContact} aria-disabled={clientPreview || undefined} className="label whitespace-nowrap text-mute transition-colors duration-150 ease-out hover:text-ink" data-id="element-40" data-mp="2hiatyxo6uera">
              Contact Portal
            </button>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-portal px-6 pb-32 pt-14 sm:px-10 sm:pt-20" data-id="element-41" data-mp="3o0amnocacs8c">{children}</main>

      <footer className="border-t border-rule" data-id="element-42" data-mp="pin6vns0yguk">
        <div className="mx-auto flex max-w-portal flex-wrap items-center justify-between gap-4 px-6 py-8 sm:px-10" data-id="element-43" data-mp="phc49rabff51">
          <p className="label m-0 text-mute" data-id="element-44" data-mp="kl55cigc73wl">
            {activeProject.client} · {activeProject.name}
          </p>
          <div className="flex flex-wrap items-center gap-8" data-id="element-45" data-mp="at8zumbx8bic">
            {/* Kept quietly here so somebody else on this computer can take over. */}
            <button type="button" onClick={clientPreview ? undefined : changeClientName} aria-disabled={clientPreview || undefined} className="label m-0 text-mute transition-colors duration-150 ease-out hover:text-ink" data-id="element-46" data-mp="189em35yp11gv">
              Change Name
            </button>
            <button type="button" onClick={openContact} aria-disabled={clientPreview || undefined} className="label m-0 text-mute transition-colors duration-150 ease-out hover:text-ink" data-id="element-47" data-mp="rz5khx9s0kua">
              Portal Productions · Dubai
            </button>
          </div>
        </div>
      </footer>

      <ContactPortal open={contactOpen} onClose={() => setContactOpen(false)} data-id="element-48" data-mp="1bo691kcqqsl4" />
    </div>;
}